import React from 'react';

export const DesciptionIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_77_18762)">
                <path d="M8 16H16V18H8V16ZM8 12H16V14H8V12ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="#AFAFAF" />
            </g>
            <defs>
                <clipPath id="clip0_77_18762">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ChangeThumbIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_77_18759)">
                <path d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z" fill="#AFAFAF" />
            </g>
            <defs>
                <clipPath id="clip0_77_18759">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const TrashIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_77_18756)">
                <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" fill="#AFAFAF" />
            </g>
            <defs>
                <clipPath id="clip0_77_18756">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const EditIcon = ({ size = 14 }: { size?: number}) => (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_77_12733)">
        <path d="M8.20167 5.26167L8.73833 5.79833L3.45333 11.0833H2.91667V10.5467L8.20167 5.26167ZM10.3017 1.75C10.1558 1.75 10.0042 1.80833 9.89333 1.91917L8.82583 2.98667L11.0133 5.17417L12.0808 4.10667C12.3083 3.87917 12.3083 3.51167 12.0808 3.28417L10.7158 1.91917C10.5992 1.8025 10.4533 1.75 10.3017 1.75ZM8.20167 3.61083L1.75 10.0625V12.25H3.9375L10.3892 5.79833L8.20167 3.61083Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_77_12733">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

export const ThumbIcon = () => {
    return (
        <svg width="44" height="41" viewBox="0 0 44 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.497393" y="0.500025" width="34.9142" height="32.4807" rx="3.83412" transform="matrix(1.00082 0.00100782 -0.00602882 0.999042 3.8239 3.52342)" fill="#FBFBFB" stroke="#CDD4DE" />
            <g clipPath="url(#clip0_77_14977)">
                <rect width="15.4071" height="14.3632" transform="matrix(1.00082 0.00100785 -0.0060288 0.999042 13.9336 13.9272)" fill="#FBFBFB" />
                <path d="M21.6434 13.935C23.0422 13.9364 24.3302 14.2585 25.5076 14.9011C26.685 15.5438 27.615 16.4151 28.2977 17.5151C28.9804 18.615 29.3179 19.8158 29.31 21.1175C29.3021 22.4191 28.9502 23.6192 28.2543 24.7178C27.5583 25.8164 26.6177 26.6858 25.4326 27.3261C24.2475 27.9664 22.9556 28.2858 21.5569 28.2844C20.1581 28.283 18.87 27.961 17.6927 27.3183C16.5153 26.6756 15.5853 25.8043 14.9026 24.7044C14.2199 23.6044 13.8824 22.4036 13.8903 21.102C13.8982 19.8003 14.2501 18.6002 14.946 17.5016C15.642 16.4031 16.5825 15.5336 17.7677 14.8933C18.9528 14.253 20.2447 13.9336 21.6434 13.935ZM25.452 21.6274C25.6668 21.5155 25.7749 21.3444 25.7763 21.1139C25.7777 20.8835 25.6717 20.7121 25.4582 20.5998L20.0151 17.6048C19.8083 17.4863 19.5942 17.483 19.3726 17.5948C19.1578 17.713 19.0496 17.8872 19.0482 18.1177L19.0122 24.0966C19.0108 24.327 19.1168 24.5015 19.3302 24.6201C19.437 24.67 19.544 24.695 19.651 24.6951C19.7648 24.6952 19.8721 24.6673 19.9728 24.6114L25.452 21.6274Z" fill="#DCDFE7" />
            </g>
            <defs>
                <clipPath id="clip0_77_14977">
                    <rect width="15.4071" height="14.3632" fill="white" transform="matrix(1.00082 0.00100785 -0.0060288 0.999042 13.9336 13.9272)" />
                </clipPath>
            </defs>
        </svg>
    );
};


export const UploadIcon = () => {
    return (
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_77_15109)">
                <path d="M48.7497 40.6252V48.7502H16.2497V40.6252H10.833V48.7502C10.833 51.7293 13.2705 54.1668 16.2497 54.1668H48.7497C51.7288 54.1668 54.1663 51.7293 54.1663 48.7502V40.6252H48.7497ZM18.958 24.3752L22.7768 28.1939L29.7913 21.2064V43.3335H35.208V21.2064L42.2226 28.1939L46.0413 24.3752L32.4997 10.8335L18.958 24.3752Z" fill="#E8E8E8" />
            </g>
            <defs>
                <clipPath id="clip0_77_15109">
                    <rect width="65" height="65" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};

export const VideoDragHandle = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="1" width="18" height="22" rx="4" fill="#E7E7E7" />
            <path fillRule="evenodd" clipRule="evenodd" d="M9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM7 12C7 10.9 7.9 10 9 10C10.1 10 11 10.9 11 12C11 13.1 10.1 14 9 14C7.9 14 7 13.1 7 12ZM9 20C10.1 20 11 19.1 11 18C11 16.9 10.1 16 9 16C7.9 16 7 16.9 7 18C7 19.1 7.9 20 9 20ZM17 6C17 7.1 16.1 8 15 8C13.9 8 13 7.1 13 6C13 4.9 13.9 4 15 4C16.1 4 17 4.9 17 6ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM13 18C13 16.9 13.9 16 15 16C16.1 16 17 16.9 17 18C17 19.1 16.1 20 15 20C13.9 20 13 19.1 13 18Z" fill="black" fillOpacity="0.54" />
        </svg>
    )
}